import { useMemo } from "react";
import { calculateLayout } from "../services/layoutEngine";
/**
 * Hook to calculate and apply automatic layout to flow nodes
 *
 * Uses the dagre layout engine to position nodes hierarchically based on their relationships.
 * The layout calculation is memoized to avoid unnecessary recalculations.
 *
 * @param nodes - Array of flow nodes to position
 * @param edges - Array of edges defining relationships between nodes
 * @param options - Optional layout configuration (direction, spacing)
 * @returns Array of nodes with calculated positions
 *
 * @example
 * ```tsx
 * const layoutedNodes = useFlowLayout(nodes, edges, {
 *   direction: 'TB',
 *   nodeSpacing: 100,
 *   rankSpacing: 150
 * });
 * ```
 */
export function useFlowLayout(nodes, edges, options) {
    return useMemo(() => {
        // Return empty array if no nodes
        if (nodes.length === 0) {
            return [];
        }
        // Calculate layout using the layout engine service
        return calculateLayout(nodes, edges, options);
    }, [nodes, edges, options]);
}
